export default {
  审计管理列表: "审计管理列表",
  拜访管理列表: "拜访管理列表",
  添加: "添加",
  导入: "导入",
  供应商: "供应商",
  物料: "物料",
  "请输入供应商编号/名称": "请输入供应商编号/名称",
  "请输入物料编号/名称": "请输入物料编号/名称",
  拜访类型: "拜访类型",
  请选择拜访类型: "请选择拜访类型",
  物料类别: "物料类别",
  请选择物料类别: "请选择物料类别",
  负责人: "负责人",
  请选择负责人: "请选择负责人",
  工厂: "工厂",
  请选择工厂: "请选择工厂",
  审计方式: "审计方式",
  请选择审计方式: "请选择审计方式",
  拜访状态: "拜访状态",
  供应商阶段: "供应商阶段",
  供应商编号: "供应商编号",
  供应商名称: "供应商名称",
  二级物料类别: "二级物料类别",
  供货物料: "供货物料",
  上一年度采购金额: "上一年度采购金额",
  "上一年度采购金额（HKD）": "上一年度采购金额（HKD）",
  拜访日期: "拜访日期",
  操作: "操作",
  审计状态: "审计状态",
  审计需求工厂: "审计需求工厂",
  审计日期: "审计日期",
  待通知供应商: "待通知供应商",
  待拜访: "待拜访",
  拜访中: "拜访中",
  待提交拜访结果: "待提交拜访结果",
  已结束: "已结束",
  待供应商提供文件: "待供应商提供文件",
  待审计: "待审计",
  审计中: "审计中",
  待提交审计结果: "待提交审计结果",
  巩固战略伙伴关系: "巩固战略伙伴关系",
  解决特定业务问题: "解决特定业务问题",
  现场评估与审核: "现场评估与审核",
  日常沟通: "日常沟通",
  现场审计: "现场审计",
  纸质审计: "纸质审计",
  远程审计: "远程审计",
  第三方审计: "第三方审计",
  查看: "查看",
  编辑: "编辑",
  删除: "删除",
  通知供应商: "通知供应商",
  填写拜访结果: "填写拜访结果",
  填写审计结果: "填写审计结果",
  供应商拜访登记表: "供应商拜访登记表",
  添加审计记录: "添加审计记录",
  编辑拜访记录: "编辑拜访记录",
  编辑审计记录: "编辑审计记录",
  查看拜访记录: "查看拜访记录",
  查看审计记录: "查看审计记录",
  导入审计记录: "导入审计记录",
  供应商信息: "供应商信息",
  国家: "国家",
  "省份/城市": "省份/城市",
  "街道/门牌号": "街道/门牌号",
  物料信息: "物料信息",
  请输入供货物料: "请输入供货物料",
  拜访信息: "拜访信息",
  审计信息: "审计信息",
  "拜访频次（次/年）": "拜访频次（次/年）",
  请输入拜访频次: "请输入拜访频次",
  开始日期: "开始日期",
  结束日期: "结束日期",
  至: "至",
  请选择完整的拜访日期范围: "请选择完整的拜访日期范围",
  拜访原因: "拜访原因",
  请输入拜访原因: "请输入拜访原因",
  拜访内容: "拜访内容",
  请输入拜访内容: "请输入拜访内容",
  拜访准备资料: "拜访准备资料",
  拜访结果: "拜访结果",
  审计结果: "审计结果",
  拜访会议纪要: "拜访会议纪要",
  请输入拜访会议纪要: "请输入拜访会议纪要",
  会议相关资料: "会议相关资料",
  请选择审计需求工厂: "请选择审计需求工厂",
  审计原因: "审计原因",
  请输入审计原因: "请输入审计原因",
  审计内容: "审计内容",
  请输入审计内容: "请输入审计内容",
  审计等级: "审计等级",
  请选择审计等级: "请选择审计等级",
  审计结果评价: "审计结果评价",
  请输入审计结果评价: "请输入审计结果评价",
  附件: "附件",
  上传文件: "上传文件",
  文件上传: "文件上传",
  点击上传: "点击上传",
  请先选择要导入的文件: "请先选择要导入的文件",
  "只能上传 Excel 文件": "只能上传 Excel 文件",
  "文件大小不能超过 10MB": "文件大小不能超过 10MB",
  导入成功: "导入成功",
  "导入失败,请重试": "导入失败,请重试",
  模板下载成功: "模板下载成功",
  "模板下载失败，请重试": "模板下载失败，请重试",
  "1. 下载导入模板": "1. 下载导入模板",
  下载模板: "下载模板",
  "请先下载模板,按照模板格式填写数据后再导入":
    "请先下载模板,按照模板格式填写数据后再导入",
  "2. 上传文件": "2. 上传文件",
  选择文件: "选择文件",
  "支持 .xls 和 .xlsx 格式,文件大小不超过 10MB":
    "支持 .xls 和 .xlsx 格式,文件大小不超过 10MB",
  确定导入: "确定导入",
  确认通知: "确认通知",
  "您确定要通知供应商吗？": "您确定要通知供应商吗？",
  确定: "确定",
  取消: "取消",
  通知供应商成功: "通知供应商成功",
  "通知供应商失败，请重试": "通知供应商失败，请重试",
  记录ID不存在: "记录ID不存在",
  填写拜访结果成功: "填写拜访结果成功",
  填写拜访结果失败: "填写拜访结果失败",
  请先选择供应商: "请先选择供应商",
  请选择拜访日期: "请选择拜访日期",
  修改并通知成功: "修改并通知成功",
  提交并通知成功: "提交并通知成功",
  提交成功: "提交成功",
  操作失败: "操作失败",
  加载拜访记录详情失败: "加载拜访记录详情失败",
  获取供应商列表失败: "获取供应商列表失败",
  获取供应商详细信息失败: "获取供应商详细信息失败",
  修改审计记录成功: "修改审计记录成功",
  新增审计记录成功: "新增审计记录成功",
  填写审计结果成功: "填写审计结果成功",
  填写审计结果失败: "填写审计结果失败",
  加载审计记录详情失败: "加载审计记录详情失败",
  获取供应商信息失败: "获取供应商信息失败",
  "共 {{count}} 条数据": "共 {{count}} 条数据",
  请输入供应商编号搜索: "请输入供应商编号搜索",
  优秀: "优秀",
  良好: "良好",
  合格: "合格",
  不合格: "不合格",
  文件: "文件",
};
